query GetSavedFilterCount($url: String!) {
    savedFilterCount(url: $url) {
        value
        suffix
        prefix
        formatted
    }
}
